import React, { PropTypes, Component } from 'react'
import styles from './styles'

export default class AuthPage extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    me: PropTypes.object,
    showError: PropTypes.bool,
  };

  constructor (props) {
    super(props)
    this.handleSubmit = ::this.handleSubmit
  }

  handleSubmit (event) {
    event.preventDefault()

    const username = this.refs.username.value
    const password = this.refs.password.value

    this.props.onSubmit(username, password)
  }

  render () {
    return (
      <div className={styles.authPage}>
        <form onSubmit={this.handleSubmit}>
          <div className={styles.inputCol}>
            <input placeholder="使用者名稱" ref="username" /><br />
            <input placeholder="密碼" ref="password" type="password" /><br />
          </div>
          <div className={styles.submitRow}>
            <input type="submit" value="登入" />
          </div>
          {this.props.showError ?
            <div className={styles.errorMessageBox}>使用者名稱或密碼錯誤</div> :
            null
          }
        </form>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/authPage/index.jsx